module.exports = __webpack_public_path__ + "static/media/subtract 5.53fa8580.webp";